// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"25":"74b49a29e5268f93df0a","662":"ffb03728fe6e5c8dd3db","733":"34d146b42151e9b0b967","793":"1b80f6a2abb57ed934ad"}[chunkId] + ".js";
};